export const features = {
    "template": "template2",
    "companyName": "Southern Pioneer Property & Casualty Insurance Company (Model)",
    "inowEndpoint": "https://sppc-model.nu-1-us-west-2.guidewire.net",
    "tokenIssuer": "https://sppc-inow.oktapreview.com/oauth2/default",
    "clientId": "0oabtlz7z6dVEPrN31d7",
    "features": {
        "CustomContentPage1": false,
        "CustomContentPage2": false,
        "addRegistrationEmail": false,
        "agentEmail": true,
        "agentLink": true,
        "agentPanel": true,
        "blockAchNumberOps": true,
        "changeCoverage": false,
        "claimDetailsDocuments": true,
        "claimDetailsPayments": true,
        "claimDocumentUpload": true,
        "claimList": true,
        "claimStatus": true,
        "combinePolicies": true,
        "coverageDetails": true,
        "cpPortalLinking": false,
        "customPrivacyStatement": false,
        "customTOS": false,
        "deactivateUserOnly": false,
        "defaultLossDateTime": true,
        "editPayPlan": false,
        "hasOpenBalance": true,
        "loginPanelExpirationDate": "2999-01-01",
        "mfaEnabled": false,
        "needHelp": false,
        "notificationPreferences": false,
        "otherPaymentAmountAllowed": true,
        "paperlessChoiceUpdate": true,
        "passwordResetInfo": true,
        "payPlanTypesToFilter": [
            "Mortgagee",
            "Agent",
            "Statement"
        ],
        "pendingOrScheduledPaymentsList": true,
        "policyDocumentUpload": false,
        "policyForms": false,
        "policyFormsDownload": false,
        "policyUserAttachmentsDisplay": false,
        "printButtonEnabled": false,
        "recentPaymentsList": true,
        "rememberMe": true,
        "reportClaim": true,
        "scheduledPayments": false,
        "showImageTag": true,
        "standardPhoneLength": false,
        "unauthenticatedPayments": true,
        "unauthenticatedReportClaim": true,
        "useInsuredAttachments": false,
        "verifyAddress": true,
        "viewChangeRequests": false
    },
    "keys": {
        "googleAnalytics": null,
        "googleAnalytics4": null,
        "googleAnalytics4GwDev": "G-R8Y22B4GYL",
        "googleAnalytics4GwProd": "G-C0D8F7WEDX",
        "googlePlacesApi": "AIzaSyDI7HC2MXBSd2C8H1ueOAEa5tEjZ1hh0i8"
    },
    "salesPortalUrl": "",
    "cpProducts": [
        "Homeowners",
        "Personal Auto"
    ],
    "paymentApiUrl": "https://midas.api.omega2-andromeda.guidewire.net/",
    "paymentTenantName": "tenant.sppc",
    "paymentConfigIds": {
        "SPPC": "5366703"
    },
    "paymentMethods": [
        "CC"
    ],
    "anonymousPaymentMethods": [
        "CC"
    ],
    "achEntryClassCode": "WEB",
    "processingFee": 0,
    "maxUploadFileSize": "500mb",
    "attachmentTemplatesLimit": "30",
    "policiesCountLimit": "50",
    "billingAccountsCountLimit": "50",
    "faviconFileExtension": "ico",
    "policyCreatedSinceDt": 365,
    "policyStatusCd": "Active,Non-Renewed,Cancel Notice",
    "passwordConstraints": [
        {
            "constraint": "minLength",
            "value": 7,
            "message": "Use at least 7 characters"
        },
        {
            "constraint": "minNumber",
            "value": 1,
            "message": "Contain at least one number"
        },
        {
            "constraint": "minLowerCase",
            "value": 1,
            "message": "Contain at least one lower case letter"
        },
        {
            "constraint": "minUpperCase",
            "value": 1,
            "message": "Contain at least one upper case letter"
        }
    ],
    "userIdConstraints": [
        {
            "constraint": "minLength",
            "value": 3,
            "message": "Use at least 3 characters"
        }
    ],
    "downTime": {
        "beginTime": "2020-01-01T17:00-05:00",
        "endTime": "2020-12-31T17:00-05:00"
    },
    "notificationSmsNumber": "123-456-7890",
    "billingStatusCd": "Normal, Cancel, Legal",
    "_meta": {
        "build": "4.0.0-9-9939c4f",
        "commit": "9939c4f26bd04651ad71a5f9aee87d57fa4bed73",
        "company": "sppc",
        "date": "2024-12-04T17:39:46+00:00",
        "source": "serviceportal-four-config",
        "version": "4.0.0",
        "imageTag": ""
    }
};